import { render, staticRenderFns } from "./Goodslist.vue?vue&type=template&id=f44aa836&scoped=true&"
import script from "./Goodslist.vue?vue&type=script&lang=js&"
export * from "./Goodslist.vue?vue&type=script&lang=js&"
import style0 from "./Goodslist.vue?vue&type=style&index=0&id=f44aa836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44aa836",
  null
  
)

export default component.exports